import React from 'react';
import { IProps, IState } from './types';
import _ from 'lodash';
import service from 'bff/services/travelInsHomeService';
import { Program } from 'bff/models/product';
import { storageKeys } from 'constants/enums/storageKeys.enum';
import { InsType as InsTypeEnum } from 'constants/enums/insType.enum';
import InsTypeDefinesEN from 'constants/models/insTypeDefinesEN';
import { CodeId } from 'constants/enums/codeId.enum';
import commonService from 'utils/commonService';
import storageService from 'utils/storageService';
import MainVisual from 'components/Home/MainVisual';
// Swiper 函式庫於 loop 模式有渲染的 bug，故更換函式庫 (2024/07/15)
// import ProdKind from 'components/Home/ProdKind';
import ProdKind02 from 'components/Home/ProdKind02';
import ProdFeature from 'components/Home/ProdFeature';
import InsureRules from 'components/Home/InsureRules';
import FlowRemind from 'components/Home/FlowRemind';
import Activity from 'components/Home/Activity';
import Service from 'components/Home/Service';
import ProdInfo from 'components/Home/ProdInfo';

class ProductTravelIns extends React.Component<IProps, IState> {
  private sectionProdKindRef = React.createRef() as React.RefObject<HTMLDivElement>;

  readonly state: IState = {
    inscat: {
      BRIEF: '',
      NOTE: '',
      INS_TYPE_NAME: '',
      INS_TYPE_ID: '',
      IMAGE_LEFT_MOBILE: '',
      IMAGE_LEFT_PC: '',
      INS_TYPE_HOME_URL: '',
      SN: 0,
      IMAGE_RIGHT_PC: '',
      IMAGE_RIGHT_MOBILE: ''
    },
    programs: [],
    products: [],
    features: [],
    flows: [],
    ageLimits: {
      AGE_LIMIT: [new Array(0)]
    },
    activities: {
      ACTIVITY: [],
      MORE_ACTIVITY_URL: ''
    },
    serviceLinks: [],
    creditCardCode: [],
    bulletin: {
      BULLETIN: {}
    },
    UICode: [],
    programId: '',
    prodInfo: []
  }

  async componentDidMount () {
    commonService.scrollToTop();

    let programId = this.props.match.params.programId || '';
    if (!this.props.match.params.programId && storageService.getItem(storageKeys.TravelProgramCode)) {
      programId = storageService.getItem(storageKeys.TravelProgramCode);
    }

    const initSettingRes = await service.fetchInitSetting(programId);

    this.setState({
      inscat: { ...initSettingRes.inscat },
      programs: [...initSettingRes.programs],
      products: [...initSettingRes.products],
      features: [...initSettingRes.features],
      flows: [...initSettingRes.flows],
      ageLimits: { ...initSettingRes.ageLimits },
      activities: { ...initSettingRes.activities },
      serviceLinks: [...initSettingRes.serviceLinks],
      creditCardCode: [...initSettingRes.creditCardCode],
      bulletin: { ...initSettingRes.bulletin },
      UICode: [...initSettingRes.UICode],
      programId, // 於旅平首頁網址攜帶活動代碼
      prodInfo: [
        {
          title: commonService.getCodeMsg(initSettingRes.UICode, CodeId.U201),
          describe: commonService.htmlParser(commonService.getCodeMsg(initSettingRes.UICode, CodeId.U202)),
          img: require('../../../assets/images/travel-prod-info-01.png')
        },
        {
          title: commonService.getCodeMsg(initSettingRes.UICode, CodeId.U203),
          describe: commonService.htmlParser(commonService.getCodeMsg(initSettingRes.UICode, CodeId.U204)),
          img: require('../../../assets/images/travel-prod-info-02.png')
        },
        {
          title: commonService.getCodeMsg(initSettingRes.UICode, CodeId.U205),
          describe: commonService.htmlParser(commonService.getCodeMsg(initSettingRes.UICode, CodeId.U206)),
          img: require('../../../assets/images/travel-prod-info-03.png')
        },
        {
          title: commonService.getCodeMsg(initSettingRes.UICode, CodeId.U207),
          describe: commonService.htmlParser(commonService.getCodeMsg(initSettingRes.UICode, CodeId.U208)),
          img: require('../../../assets/images/travel-prod-info-04.png')
        }
      ]
    });
  }

  componentDidUpdate (preProps: IProps, preState: IState) {
    /** 判斷公告事項是否更新，顯示公告事項 */
    this.handleShowBulletin(preState);
  }

  /**
   * @description 有公告事項，顯示公告
   */
  handleShowBulletin = (preState:any) => {
    const showAnnounce = Object.keys(preState.bulletin.BULLETIN).length !== Object.keys(this.state.bulletin.BULLETIN).length &&
      this.state.bulletin && this.state.bulletin.BULLETIN && this.state.bulletin.BULLETIN.END_TIME;

    if (showAnnounce && !storageService.getItem(storageKeys.TravelInsAnnounceChecked)) {
      commonService.showAnnounceModal(
        this.state.bulletin.BULLETIN.END_TIME || '', this.state.bulletin.BULLETIN.TITLE, this.state.bulletin.BULLETIN.CONTENT
      );
      storageService.setItem(storageKeys.TravelInsAnnounceChecked, 'checked');
    }
  }

  /**
   * @description 「主視覺」區塊點擊 SCROLL 按鈕，視窗滾動至下一個區塊 (商品種類)
   */
  handleMainVisualScrollToNextSection = () => {
    const headerHeight = document.getElementsByTagName('header')[0].clientHeight;
    if (this.sectionProdKindRef && this.sectionProdKindRef.current) {
      window.scrollTo({ top: this.sectionProdKindRef.current.offsetTop - headerHeight, behavior: 'smooth' });
    }
  }

  render () {
    // #region 主視覺
    let mainVisual;
    if (this.state.inscat.INS_TYPE_ID) {
      const backgroundImages = [
        {
          theme: InsTypeDefinesEN[InsTypeEnum.Travel],
          // pcLeftImgPath: require(`assets/images/${this.state.inscat.IMAGE_LEFT_PC}`),
          // pcRightImgPath: require(`assets/images/${this.state.inscat.IMAGE_RIGHT_PC}`),
          // mobileImgPath: require(`assets/images/${this.state.inscat.IMAGE_LEFT_MOBILE}`)
          pcLeftImgPath: commonService.convertImageUrl(this.state.inscat.IMAGE_LEFT_PC),
          pcRightImgPath: commonService.convertImageUrl(this.state.inscat.IMAGE_RIGHT_PC),
          mobileImgPath: commonService.convertImageUrl(this.state.inscat.IMAGE_LEFT_MOBILE)
        }
      ];

      let newsAds;
      if (this.state.programs.length > 0) {
        newsAds = _.map(this.state.programs, (program: Program) => ({
          title: program.PROGRAM_NAME,
          content: program.NOTE
        }));
      }

      mainVisual = (
        <MainVisual
          title={this.state.inscat.BRIEF}
          subTitle={this.state.inscat.INS_TYPE_NAME}
          newsAds={newsAds}
          backgroundImages={backgroundImages}
          scrollDownBtnText="我要試算"
          onScroll={this.handleMainVisualScrollToNextSection}
        />
      );
    }
    // #endregion

    // #region 投保流程及溫馨提醒
    let flowRemind;
    if (this.state.flows && this.state.flows.length > 0) {
      const flow = { ...this.state.flows[0] };
      const flowItems = [
        {
          // icon: require(`assets/images/${flow.IMAGE_NAME_PC_1}`),
          icon: commonService.convertImageUrl(flow.IMAGE_NAME_PC_1),
          text: flow.BRIEF_1,
          title: flow.FLOW_TITLE_1
        },
        {
          // icon: require(`assets/images/${flow.IMAGE_NAME_PC_2}`),
          icon: commonService.convertImageUrl(flow.IMAGE_NAME_PC_2),
          text: flow.BRIEF_2,
          title: flow.FLOW_TITLE_2
        },
        {
          // icon: require(`assets/images/${flow.IMAGE_NAME_PC_3}`),
          icon: commonService.convertImageUrl(flow.IMAGE_NAME_PC_3),
          text: flow.BRIEF_3,
          title: flow.FLOW_TITLE_3
        },
        {
          // icon: require(`assets/images/${flow.IMAGE_NAME_PC_4}`),
          icon: commonService.convertImageUrl(flow.IMAGE_NAME_PC_4),
          text: flow.BRIEF_4,
          title: flow.FLOW_TITLE_4
        }
      ];

      let remindAccordion;
      if (this.state.creditCardCode.length > 0) {
        remindAccordion = [
          {
            title: this.state.creditCardCode[0].NOTE,
            content: commonService.getCodeMsg(this.state.creditCardCode, CodeId.CCBANK)
          }
        ];
      }

      flowRemind = (
        <FlowRemind title="投保流程及溫馨提醒">
          <FlowRemind.Flow
            items={flowItems}
            sliderMobileConfig={{ slidesPerView: 2 }}
          />
          <FlowRemind.Remind accordion={remindAccordion}>
            {
              _.map(flow.REMIND_MSG, (str: string, index: number) => {
                return React.cloneElement(
                  <>
                    {str}<br />
                  </>
                  , { key: index });
              })
            }
          </FlowRemind.Remind>
        </FlowRemind>
      );
    }
    // #endregion

    return (
      <div className="product-travel-ins">
        {/* 主視覺 */}
        {mainVisual}
        {/* 商品種類 */}
        <ProdKind02
          products={this.state.products}
          sliderName={InsTypeDefinesEN[InsTypeEnum.Travel]}
          refSetting={this.sectionProdKindRef}
          slidesPerView={3}
          programId={this.state.programId}
        />
        {/* 商品特色 */}
        <ProdFeature features={this.state.features} />
        {/* 商品介紹 */}
        <ProdInfo
          prodInfo={this.state.prodInfo}
        />
        {/* 投保規則 */}
        <InsureRules>
          <InsureRules.TravelInsureRules ageLimits={this.state.ageLimits.AGE_LIMIT} remindText={commonService.getCodeMsg(this.state.UICode, CodeId.U014)} />
        </InsureRules>
        {/* 投保流程及溫馨提醒 */}
        {flowRemind}
        {/* 熱門活動 */}
        <Activity activities={this.state.activities} moreActivityText={commonService.getCodeMsg(this.state.UICode, CodeId.U017)} />
        {/* 常用服務 */}
        <Service serviceLinks={this.state.serviceLinks} />
      </div>
    );
  }
}

export default ProductTravelIns;
